import {type MapLocationRequest, type ModalProps, MapClusterer, Modal} from '@yandex-delivery/blocks'
import {useI18n} from '@yandex-delivery/core/i18n'
import {type ReactElement, useState} from 'react'

import type {AddressPin, PickupPoint, PickupPointFeature, PickupPoints, PickupTarget} from '../../types'
import {isUserAddressPin} from '../../utils'
import {DetailShortModal} from '../DetailShortModal/DetailShortModal'
import {PointMarker} from '../PointMarker/PointMarker'
import {toCenterLocation} from '../utils'
import * as classes from './MapModePoints.classes'
import {renderCluster, renderMarker} from './utils'

type Props = {
  target: PickupTarget
  points?: PickupPoints
  addressPin?: AddressPin
  onLocationChange(location: MapLocationRequest): void
  onPickupPointChange(pickupPoint: PickupPoint): void
}
type State = {
  opened: boolean
  feature: PickupPointFeature
}

const backdropProps: ModalProps['backdrop'] = {
  className: classes.backdrop,
}

export function MapModePoints(props: Props): ReactElement {
  const {
    target,
    points,
    addressPin,
    onLocationChange: locationChangeHandler,
    onPickupPointChange: pickupPointChangeHandler,
  } = props
  const [state, setState] = useState<State | null>(null)
  const i18n = useI18n()

  return (
    <>
      {points && (
        <MapClusterer
          cluster={renderCluster(locationChangeHandler)}
          features={points.features}
          marker={renderMarker({
            children:
              target === 'destination'
                ? i18n('bdui.pickup_points.map.pickup-point', 'Пункт выдачи')
                : i18n('bdui.pickup_points.map.dropoff-point', 'Пункт приёма'),
            selectedFeature: state && state.opened ? state.feature : undefined,
            onFeatureClick(feature) {
              setState({
                opened: true,
                feature,
              })
              locationChangeHandler(toCenterLocation(feature.geometry.coordinates, 16))
            },
          })}
        />
      )}
      {isUserAddressPin(addressPin) && <PointMarker coordinates={addressPin.coordinates} type="source" draggable />}
      {state && (
        <Modal.SidePanel anchor="bottom" backdrop={backdropProps} className={classes.sidePanel} opened={state.opened}>
          <DetailShortModal
            onBackButtonClick={() => {
              setState({
                ...state,
                opened: false,
              })
            }}
            onPickupPointChange={pickupPointChangeHandler}
            pickupPoint={state.feature.pickupPoint}
          />
        </Modal.SidePanel>
      )}
    </>
  )
}
